import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { applyDarkClass, getStoredTheme, setStoredTheme } from "../theme";

export default function ThemeToggle() {
  const [mode, setMode] = useState<string>(getStoredTheme());

  useEffect(() => {
    applyDarkClass(mode);
    setStoredTheme(mode);
  }, [mode]);

  return (
    <button
      aria-label="Toggle dark mode"
      onClick={() => setMode((m) => (m === "dark" ? "light" : "dark"))}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md border bg-background text-foreground hover:bg-accent"
    >
      {mode === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}



